import Image, { ImageProps } from 'next/image';
import { forwardRef, useMemo, useState } from 'react';

import { convertCdnUrl } from '@/utils/js/condition';

type CustomImageProps = Omit<ImageProps, 'src'> & {
  src?: string | null;
};

const NO_IMAGE_URL = convertCdnUrl('/noimage.svg');

const CustomImage = forwardRef<HTMLImageElement, CustomImageProps>(
  ({ src, alt = '', ...props }, ref) => {
    const [isError, setIsError] = useState(false);

    const validatedUrl = useMemo(() => {
      if (!src) return null;
      return src;
    }, [src]);

    const imageSource = isError ? NO_IMAGE_URL : validatedUrl;

    if (!validatedUrl && !isError) return null;
    return (
      <Image
        ref={ref}
        src={imageSource || NO_IMAGE_URL}
        alt={alt}
        {...props}
        onError={() => setIsError(true)}
      />
    );
  },
);

CustomImage.displayName = 'CustomImage';

export default CustomImage;
